module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "FRONTMATTER"
    }
  }, [_c('p', {
    staticClass: "h2f",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rint"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In focus, "), _c('i', [_vm._v("The Sacred Slow")]), _vm._v(" is more like a marathon than a one-hundred-yard dash. The finish line will not be visible from the starting block.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In intensity, this holy departure from Fast Faith will feel more like a thru-hike than a morning workout. A high-energy start would be counterproductive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In composition, these fifty-two experiences in unhurried honesty with God will build on and benefit deeply from every book, retreat, and Bible study you have known and still be "), _c('i', [_vm._v("other")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps it will help to understand my role in your reading. At our cores, my husband and I are both people-growers. Over the decades, some have referred to us as mentors, spiritual directors, or healthy-soul coaches. Whatever the label, our focus is prayerfully guiding learners and leaders into intentional and sustainable intimacy with God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you were to commit to fifty-two mentoring sessions with us, the essential content we would work through together is what you hold in your hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After twenty-five years of providing customized spiritual mentoring, I spent the twenty-sixth year designing "), _c('i', [_vm._v("The Sacred Slow")]), _vm._v(" and then the next five years field-testing its content. Every sentence you are about to read is rooted in three certainties:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "nlist"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("1."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Moment-by-moment nearness with God can be a reality for all sincere followers of Jesus regardless of personality or position in life.")])]), _vm._v(" "), _c('p', {
    staticClass: "nlist"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Though such intimacy with God is attainable, it is not accidental. Sustained nearness is the cultivated fruit of intentionality.")])])]), _vm._v(" "), _c('p', {
    staticClass: "nlist"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("3."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Spiritual intentionality connects us with God and with what He sees, celebrates, and weeps over.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("In other words, intimacy with God is not the exclusive domain of monks in monasteries or contemplatives in cloister. Right where you are, in moments both ordinary and extraordinary, you and Jesus can live attentive to each other. Whatever your work, it can be done in Jesus, with Jesus, and for Jesus. Nearness with God in no way dooms us to drown in the depths of introspection. On the contrary, it sensitizes us to the John 3:16 world that God so loved when He gave His only Son for our sins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those who have journeyed before you through this content share a similar story: they began reading something that ultimately read them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is nothing remotely passive about these pages. The readings, though conversational, are not random. The exercises, though diverse, are not disconnected. Together, each experience (I hesitate to call them chapters) will invite you into a fierce and freeing honesty about yourself, your faith, and your God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But please know that honesty alone is not the end goal of the journey. Honesty is a means to cultivating deep and enduring love. Each unhurried, honest answer to every unhurried, honest question will work together to remove layers of misthink and overdo in our souls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The twelve movements of "), _c('i', [_vm._v("The Sacred Slow")]), _vm._v(" are sequenced intentionally:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("One")]), _vm._v("—Two Stories")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Two")]), _vm._v("—Adding Intentionality")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvii",
      "title": "xvii"
    }
  }, [_c('b', [_vm._v("Three")]), _vm._v("—God-Concepts")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Four")]), _vm._v("—Self-Concepts")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Five")]), _vm._v("—Centralizing His Presence")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Six")]), _vm._v("—Relating to His Word")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Seven")]), _vm._v("—Discovering God-Prints")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Eight")]), _vm._v("—The Discipline of Restraint")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Nine")]), _vm._v("—A Theology of Time and Space")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Ten")]), _vm._v("—Unexpected Friends")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Eleven")]), _vm._v("—Sabbath and Prayer Retreats")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide1"
  }), _c('b', [_vm._v("Twelve")]), _vm._v("—The Sacred Go")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Within each movement, my responsibility is to provoke thought and press applications to mentor you in thinking anew about what God really wants from you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Your responsibility is simply to be true. Honesty is the one thing you must bring to the table. So, read (prayerfully), respond (with as much uncensored honesty as you can offer), and anticipate the renewal that only God’s love can bring.")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract"
  }, [_vm._v("Honesty is a friend of intimacy with God and, conversely, denial is an enemy of intimacy with God. . . . Fast denial. Be honest with yourself so that you can be honest with your God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780718094966_Notes#ci_rfn1",
      "id": "ci_fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fde7ee0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780718094966_Introduction.vue
// module id = 78
// module chunks = 0